import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {

  const splide = new Splide('.article-categories-slider', {
    autoWidth: true,
    pagination: false,
    arrows: false,
    gap: 16,
    role: "carousel",
  });

  splide.mount();
});